<template>
  <div class="p-3">
    <dashboard
      :total-despesas="totalDespesas"
      :meses-despesas="mesesDespesas"
    />

    <form-modal
      id="cronograma_financeiro"
      placeholder-button="Inserir parcelas não previstas"
      title-modal="Cronograma financeiro"
      :fields="colunas"
      :values="dadosTotalizados"
      ref="modalForm"
      :create="controlesLiberados && permissao.c"
      :read="controlesLiberados && permissao.r"
      :update="false"
      :remove="controlesLiberados && permissao.d"
      :esconder-botoes-modal="!controlesLiberados || itemAprovado"
      controles
      @ok="salvar"
      @edit="editar"
      @cancel="inicializarForm"
      @remove="remover"
      @downloadArquivo="downloadArquivo"
    >
      <template #title>
        <span class="mr-4">PARCELAS</span>
        <template v-if="componente == 'previsto'">
          <b-badge variant="warning" class="ml-4">
            Valor previsto da NF:
          </b-badge>
          <b-badge class="ml-2" variant="light">
            {{ formatarValor(form.valor) }}
          </b-badge>
        </template>
        <template v-if="componente == 'n_previsto'">
          <b-badge> Total rubricas: </b-badge>
          <b-badge class="ml-2" variant="light">
            {{
              formatarValor(
                totalDespesas[
                  componente == "n_previsto"
                    ? "custoRealizado"
                    : "totalRealizado"
                ]
              )
            }}
          </b-badge>

          <b-badge variant="warning" class="ml-4"> Total notas: </b-badge>
          <b-badge class="ml-2" variant="light">
            {{
              formatarValor(
                totalDespesas[
                  componente == "n_previsto" ? "notaPrevisto" : "notaRealizado"
                ]
              )
            }}
          </b-badge>

          <b-badge variant="success" class="ml-4"> Total restante: </b-badge>
          <b-badge class="ml-2" variant="light">
            {{
              formatarValor(
                totalDespesas[
                  componente == "n_previsto"
                    ? "restantePrevisto"
                    : "restanteRealizado"
                ]
              )
            }}
          </b-badge>
        </template>
      </template>

      <template #modal>
        <component
          :editando="editando"
          @notas="atualizarTotalNotas"
          :is="componente"
          :form="form"
          :projeto-id="projetoId"
          :projeto-id-base="projetoIdBase"
          :duracao="projeto.duracao"
          :data-inicio="projeto.dataInicio"
          @downloadArquivo="downloadArquivo"
          ref="modal"
        />
      </template>
      <template #buttons-prepend="item">
        <template v-if="item.data.tomadora != '-1'">
          <div
            v-if="
              item.data.desembolso
                ? item.data.desembolso.status == 'Aprovado'
                : false
            "
          >
            <b-badge variant="success">
              <i class="fa-solid fa-thumbs-up mr-2"></i>
              Aprovado
            </b-badge>
            <b-button variant="flat-primary" @click="editar(item.data)">
              <i class="fa-solid fa-file-invoice-dollar mr-2"></i>
              Visualizar notais fiscais
            </b-button>
          </div>
        </template>
        <template v-if="item.data.tomadora != '-1'">
          <b-button
            v-if="souAdmin"
            variant="flat-warning"
            class="mr-2"
            @click="editarPlanejado(item.data)"
          >
            <i class="fa-solid fa-pen-to-square mr-2"></i>
            Editar parcela planejada
          </b-button>
          <div>
            <div v-if="item.data.desembolso">
              <b-badge
                v-if="item.data.desembolso.status != 'Aprovado'"
                :variant="
                  item.data.desembolso.status == 'Pendente'
                    ? 'primary'
                    : 'danger'
                "
              >
                {{ item.data.desembolso.status }}
              </b-badge>
            </div>

            <b-button
              v-if="
                permissao.u && item.data.desembolso
                  ? item.data.desembolso.status != 'Aprovado'
                  : true
              "
              variant="flat-primary"
              @click="editar(item.data)"
            >
              <i class="fa-solid fa-file-invoice-dollar mr-2"></i>
              {{
                liberadoAprovar ||
                (item.data.desembolso
                  ? item.data.desembolso.status != "Reprovado"
                  : false) ||
                !projetoEditavel
                  ? (
                      item.data.desembolso
                        ? item.data.desembolso.status == "Pendente"
                        : false
                    )
                    ? "Visualizar/Atualizar notais fiscais"
                    : "Visualizar notais fiscais"
                  : "Emitir nota fiscal"
              }}
            </b-button>
          </div>

          <b-button
            variant="flat-success"
            class="mr-2"
            @click="aprovar(item.data)"
            v-if="
              (item.data.desembolso
                ? item.data.desembolso.status == 'Pendente'
                : false) &&
              liberadoAprovar &&
              permissao.u
            "
          >
            <i class="fa-solid fa-thumbs-up mr-2"></i>
            Aprovar
          </b-button>
          <b-button
            variant="flat-danger"
            class="mr-2"
            @click="reprovar(item.data)"
            v-if="
              (item.data.desembolso
                ? item.data.desembolso.status == 'Pendente'
                : false) &&
              liberadoAprovar &&
              permissao.u
            "
          >
            <i class="fa-solid fa-thumbs-down mr-2"></i>
            Reprovar
          </b-button>
        </template>
      </template>
    </form-modal>
  </div>
</template>
<script>
import dashboard from "./dashboard.vue";
import FormModal from "@/components/modal/FormModal";
import { AlertasMixin } from "@/common/mixins/AlertasMixin";
import { START_LOADING, STOP_LOADING } from "@/store/Store";
import cloneDeep from "lodash/cloneDeep";
import ProjetoService from "@/common/services/projeto/projeto.service";
import helpers from "@/common/utils/helpers";

export default {
  mixins: [AlertasMixin],
  name: "ProjetoCronogramaFinanceiro",
  components: {
    dashboard,
    FormModal,
    previsto: () => import("./ModalPrevisto.vue"),
    n_previsto: () => import("./ModalNPrevisto.vue"),
  },
  props: {
    projetoId: {
      type: String,
      required: true,
    },
    projetoIdBase: {
      type: String,
      required: true,
    },
    nomeIdProjeto: {
      type: String,
      required: true,
    },
    projeto: {
      type: Object,
      required: true,
    },
    endpoint: {
      type: String,
      required: true,
    },
    endpointProposta: {
      type: String,
      required: true,
    },
    projetoEditavel: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    componente: "n_previsto",
    dados: [],
    form: [],
    rubricas: {
      servicosTerceiros: [],
      recursoHumano: null,
      materiaisConsumo: [],
      materiaisPermanentesEquipamentos: [],
      viagensDiarias: [],
      outrosRecursos: [],
    },
    options: {
      empresasInvestidoras: [],
      empresasRecebedoras: [],
    },
    proposta: {
      rh: [],
      st: [],
      mc: [],
      mpe: [],
      vd: [],
      ou: [],
    },

    totalNotas: 0,
    editando: false,
    valorAntigo: 0,
    itemAprovado: false,
  }),
  methods: {
    atualizarTotalNotas(totalNotas) {
      this.totalNotas = totalNotas;
    },
    formatarValor(valor) {
      return helpers.formatarValor(valor);
    },
    salvar: function () {
      let form = cloneDeep(this.form);
      if (!this.$refs.modal.validateState()) return;

      this.confirmar("Deseja salvar desembolso?").then((confirma) => {
        if (!confirma) return;
        if (this.componente == "previsto") {
          form = form.desembolso;

          // if (this.totalDespesas.restanteRealizado < 0) {
          //   this.alertaErro(
          //     "O valor total das notas ficais não pode ser maior que o valor total das rubricas."
          //   );
          //   return;
          // }

          if (form.nomeArquivoAWSUP != null) {
            form.nomeArquivoAWS = form.nomeArquivoAWSUP;
            delete form["nomeArquivoAWSUP"];
          }

          if (!form.nomeArquivoAWS) {
            this.alertaErro("Anexar documento é obrigatório");
            return;
          }

          form.valorBruto = helpers.removerValor(form.valorBruto);
          form.impostos = helpers.removerValor(form.impostos);
          if (form.dataFaturamento.indexOf("/") > -1)
            form.dataFaturamento = helpers.formatarDataBD(form.dataFaturamento);

          form = Object.assign(
            {},
            form,
            this.options.empresasInvestidoras.find(
              (empresa) => empresa.value == form.tomador
            ).el
          );

          let empresaRecebedora = this.options.empresasRecebedoras.find(
            (empresa) => empresa.value == form.prestador
          ).el;
          form.projetoEmpresaExecutoraCriadoraId =
            empresaRecebedora.projetoEmpresaExecutoraCriadoraReceptoraId;
          form.projetoEmpresaExecutoraId =
            empresaRecebedora.projetoEmpresaExecutoraReceptoraId;

          this.$store.dispatch(START_LOADING);
          ProjetoService.salvarDesembolso(form)
            .then(() => {
              this.alertaSucesso("Desembolso salvo com sucesso!").then(() => {
                this.$refs.modalForm.closeModal();
                this.buscar();
              });
            })
            .catch((err) => {
              if (err.response.status == 400) {
                this.alertaErro(`${err.response.data.errors[0]}`);
                return;
              } else {
                this.alertaErro(
                  "Campo Nº da nota só é permitido preenchimento com números."
                );
                return;
              }
            })
            .finally(() => {
              this.$store.dispatch(STOP_LOADING);
            });
        } else {
          this.$store.dispatch(START_LOADING);
          form.forEach((item, i) => {
            item.indice = i;

            item[this.nomeIdProjeto] = this.projetoId;
            item[this.nomeIdExecutora] = this.projetoId;

            item.valor = helpers.removerValor(item.valor);

            item = Object.assign(
              {},
              item,
              this.options.empresasInvestidoras.find(
                (empresa) => empresa.value == item.empresa
              ).el
            );

            ProjetoService.salvarDesembolsoNaoPrevisto(item)
              .then(() => {
                this.toast(`Desembolso salvo com sucesso!`, {
                  variant: "success",
                  title: "Sucesso",
                });

                this.form.splice(
                  this.form.indexOf(this.form.find((el) => el.indice == i)),
                  1
                );
              })
              .catch((err) => {
                this.$store.dispatch(STOP_LOADING);
                if (err.response.status == 400) {
                  this.toast(`Erro ao salvar desembolso: ${err.data.errors}`, {
                    variant: "danger",
                    title: "Erro",
                  });
                } else {
                  this.toast(`Erro ao salvar desembolso`, {
                    variant: "danger",
                    title: "Erro",
                  });
                }
              });
          });
        }
      });
    },

    editar: function (item) {
      this.form = cloneDeep(item);
      this.editando = true;
      this.componente = "previsto";

      if (item.desembolso) {
        this.itemAprovado = item.desembolso.status == "Aprovado";
      } else {
        this.itemAprovado = false;
      }

      if (!this.form.desembolso) {
        this.valorAntigo = 0;

        this.form.desembolso = {
          cronogramaFinanceiroId: this.form.id,
          parcela: this.form.parcela,
          numero: 0,
          dataFaturamento: null,
          valorBruto: 0,
          impostos: 0,
          entregavelId: this.form.entregavel ? this.form.entregavel.id : null,
          subtipo: this.form.subtipo,
          descricao: null,
          conteudoBase64: null,
          nomeArquivoAWS: null,
          tomador: cloneDeep(
            this.form.projetoCooperadaInvestidoraId ||
              this.form.projetoInvestidoraId
          ),
          prestador: cloneDeep(
            this.form.projetoEmpresaExecutoraCriadoraId ||
              this.form.projetoEmpresaExecutoraId
          ),
        };
      } else {
        // delete this.form.desembolso.id;
        this.valorAntigo = cloneDeep(this.form.desembolso.valorBruto);
        this.form.desembolso.dataFaturamento = helpers.formatarDataBr(
          this.form.desembolso.dataFaturamento
        );
        this.form.desembolso.valorBruto = helpers.formatarValor(
          this.form.desembolso.valorBruto
        );
        this.form.desembolso.impostos = helpers.formatarValor(
          this.form.desembolso.impostos
        );
        this.form.desembolso.tomador = cloneDeep(
          this.form.desembolso.projetoCooperadaInvestidoraId ||
            this.form.desembolso.projetoInvestidoraId
        );
        this.form.desembolso.prestador = cloneDeep(
          this.form.desembolso.projetoEmpresaExecutoraCriadoraId ||
            this.form.desembolso.projetoEmpresaExecutoraId
        );
      }

      this.$refs.modalForm.openModal();
    },

    editarPlanejado: function (item) {
      this.componente = "n_previsto";
      this.editando = true;
      this.itemAprovado = false;
      this.form = [
        {
          id: item.id,
          tipo: item.tipo,
          subtipo: item.subtipo,
          prazo: item.prazo,
          valor: helpers.formatarValor(item.valor),
          parcela: item.parcela,
          entregavelId: item.entregavel ? item.entregavel.id : null,
          empresa: item.projetoInvestidoraId || item.projetoCooperadaInvestidoraId,
          previsto: item.previsto,
        },
      ];

      this.$refs.modalForm.openModal();
    },

    remover: function (item) {
      this.confirmar("Deseja remover desembolso?").then((confirma) => {
        if (!confirma) return;

        this.$store.dispatch(START_LOADING);
        ProjetoService.deletarDesembolso({ id: item.id })
          .then(() => {
            this.alertaSucesso("Desembolso removido com sucesso!").then(() => {
              this.buscar();
            });
          })
          .catch((err) => {
            if (err.response.status == 400) {
              this.alertaErro(`Erro ao remover desembolso: ${err.data.errors}`);
            } else {
              this.alertaErro(`Erro ao remover desembolso`);
            }
          })
          .finally(() => {
            this.$store.dispatch(STOP_LOADING);
          });
      });
    },

    aprovar: function (item) {
      this.confirmar("Deseja aprovar desembolso?").then((confirma) => {
        if (!confirma) return;

        this.$store.dispatch(START_LOADING);

        ProjetoService.aprovarDesembolso(item.desembolso.id)
          .then(() => {
            this.alertaSucesso("Desembolso aprovado com sucesso!").then(() => {
              this.buscar();
            });
          })
          .catch((err) => {
            if (err.response.status == 400) {
              this.alertaErro(`Erro ao aprovar desembolso`);
            } else {
              this.alertaErro(`Erro ao aprovar desembolso`);
            }
          })
          .finally(() => {
            this.$store.dispatch(STOP_LOADING);
          });
      });
    },

    reprovar: function (item) {
      this.confirmar("Deseja reprovar desembolso?").then((confirma) => {
        if (!confirma) return;

        this.$store.dispatch(START_LOADING);

        ProjetoService.reprovarDesembolso(item.desembolso.id)
          .then(() => {
            this.alertaSucesso("Desembolso reprovado com sucesso!").then(() => {
              this.buscar();
            });
          })
          .catch(() => {
            this.alertaErro(`Erro ao reprovar desembolso`);
          })
          .finally(() => {
            this.$store.dispatch(STOP_LOADING);
          });
      });
    },

    buscar: function () {
      ProjetoService.listarGenerico(
        "cronograma-financeiro",
        this.projetoId,
        this.nomeIdProjeto
      ).then((res) => {
        this.dados = res.data.data.itens.sort((a, b) => {
          if (a.parcela > b.parcela) {
            return 1;
          }
          if (a.parcela < b.parcela) {
            return -1;
          }

          if (!a.desembolso || !b.desembolso) return 0;

          if (a.desembolso.numero > b.desembolso.numero) {
            return 1;
          }
          if (a.desembolso.numero < b.desembolso.numero) {
            return -1;
          }

          return 0;
        });
      }).catch((err) => {
        console.error("Erro ao buscar cronograma financeiro:", err);
        this.alertaErro("Erro ao buscar cronograma financeiro");
      });
    },

    downloadArquivo: function (arquivoId) {
      this.$store.dispatch(START_LOADING);

      ProjetoService.setEndpoint("ProjetoEmpresaExecutora");
      ProjetoService.downloadArquivoGenerico("desembolso", arquivoId)
        .then((response) => {
          helpers.baixarArquivo(response.data, response.headers);
          this.alertaSucesso("Download do Arquivo Concluido!");
        })
        .catch((err) => {
          console.log(err);
          this.alertaErro("Erro ao fazer Download do Arquivo");
        })
        .finally(() => {
          ProjetoService.setEndpoint(this.endpoint);
          this.$store.dispatch(STOP_LOADING);
        });
    },

    inicializarForm: function () {
      this.totalNotas = 0;
      this.editando = false;
      this.valorAntigo = 0;
      this.itemAprovado = false;

      this.componente = "n_previsto";
      this.form = [
        {
          tipo: `Nota fiscal ${
            this.dados.length == 0
              ? 1
              : parseInt(
                  this.dados[this.dados.length - 1].tipo.replace(
                    "Nota fiscal ",
                    ""
                  )
                ) + 1
          }`,
          subtipo: null,
          prazo: null,
          valor: 0,
          parcela:
            this.dados.length == 0
              ? 1
              : parseInt(this.dados[this.dados.length - 1].parcela) + 1,
          entregavelId: null,
          previsto: false,
        },
      ];
    },

    buscarEmpresasInvestidoras: function () {
      ProjetoService.listarEmpresasInvestidoras(this.projetoIdBase).then(
        (res) => {
          this.options.empresasInvestidoras = res.data.data.map((el) => {
            return {
              text: el.razaoSocial,
              value:
                el.projetoInvestidoraId || el.projetoCooperadaInvestidoraId,
              el: el,
            };
          });
        }
      );
    },
    buscarEmpresasRecebedoras: function () {
      ProjetoService.listarEmpresasAssociadas(this.projetoIdBase).then(
        (response) => {
          this.options.empresasRecebedoras = response.data.data.map((el) => {
            return {
              value:
                el.projetoEmpresaExecutoraCriadoraReceptoraId ||
                el.projetoEmpresaExecutoraReceptoraId,
              text: el.razaoSocial,
              el: el,
            };
          });
        }
      );
    },

    somarValoresPrevistosProposta: function (rubrica, mes) {
      return this.proposta[rubrica]
        .filter((rubrica) => rubrica.mesDespesa == mes)
        .reduce((acc, el) => {
          return acc + el.valor;
        }, 0);
    },

    buscarRubricas: function () {
      this.$store.dispatch(START_LOADING);

      ProjetoService.buscarRubricas(this.projetoId, this.nomeIdProjeto).then(
        (res) => {
          this.rubricas = res;
        }
      ).catch((err) => {
            console.error("Erro ao buscar rubricas realizadas:", err);
            this.alertaErro("Erro ao buscar rubricas realizadas");
        }).finally(() => {
            this.$store.dispatch(STOP_LOADING); // Finaliza o indicador de carregamento
        });
    },

    somarValoresRealizados: function (rubrica, mes) {
      let meses = helpers.criarArrayMesCronogramaFinanceiro(
        this.projeto.dataInicio,
        this.projeto.duracao
      );
      return this.rubricas[rubrica]
        .filter((el) => {
          let anoEmissao = helpers.formatarData(el.dataEmissao, "YYYY");
          let mesEmissao = helpers.formatarData(el.dataEmissao, "MM");

          let x = meses.find(
            (el) => el.mes == mesEmissao && el.ano == anoEmissao
          );

          return mes == (x ? x.value : null);
        })
        .reduce((acc, el) => {
          return acc + el.valorIndividual * el.quantidade;
        }, 0);
    },

    buscarRubricasProposta: function () {
      const endpointProposta = this.endpointProposta;

      [
        { abrv: "rh", endpoint: "recurso-humano" },
        { abrv: "st", endpoint: "servico-terceiro" },
        { abrv: "mc", endpoint: "material-consumo" },
        { abrv: "mpe", endpoint: "material-permanente" },
        { abrv: "vd", endpoint: "viagem-diaria" },
        { abrv: "ou", endpoint: "outro-recurso" },
      ].forEach((element) => {
        ProjetoService.buscarRubricaProposta(
          endpointProposta,
          element.endpoint,
          this.projetoId
        )
          .then((response) => {
            let data = response.data.data;

            if (element.abrv == "rh") {
              this.proposta[element.abrv] =
                data && data.equipe ? data.equipe.alocacaoHorasIndividuais : [];
            } else {
              this.proposta[element.abrv] = data || [];
            }
          })
          .catch((err) => {
            console.error(
              `Erro ao buscar rubrica prevista (${element.endpoint}):`,
              err
            );
          })
          .finally(() => {
            this.$store.dispatch(STOP_LOADING);
          });
      });
    },
    montar() {
      this.buscar();
      this.inicializarForm();
      this.buscarEmpresasInvestidoras();
      this.buscarEmpresasRecebedoras();
      this.buscarRubricas();
      this.buscarRubricasProposta();
    },
  },

  mounted() {},
  watch: {
    form: {
      handler() {
        if (this.form.length == 0) {
          this.$refs.modalForm.closeModal();
          this.$store.dispatch(STOP_LOADING);
          this.buscar();
          this.inicializarForm();
        }
      },
      deep: true,
    },
  },
  computed: {
    permissao() {
      return this.$store.getters["app/retornaPermissao"](
        "ProjetosPdCronogramaFinanceiro"
      );
    },
    souAdmin() {
      return this.$store.getters["app/ehAdmin"];
    },
    liberadoAprovar: function () {
      return (
        (this.$route.name == "projeto-detalhamento" ||
          this.$route.name == "projeto-detalhamento-proponente-cooperada") &&
        this.projetoEditavel
      );
    },
    controlesLiberados: function () {
      return (
        (this.$route.name == "projeto-detalhamento-executora-criadora" ||
          this.$route.name == "projeto-detalhamento-executora-associada") &&
        this.projetoEditavel
      );
    },
    dadosTotalizados: function () {
      let valor = this.dados.reduce((total, el) => {
        return total + parseFloat(el.valor);
      }, 0);
      let valorRealizado = this.dados.reduce((total, el) => {
        return total + parseFloat(el.desembolso ? el.desembolso.valorBruto : 0);
      }, 0);
      return [
        ...this.dados,
        {
          tomadora: "-1",
          prestadora: null,
          valor: valor,
          desembolso: {
            valorBruto: valorRealizado,
          },
          _rowVariant: "warning",
        },
      ];
    },
    totalDespesas: function () {
      let custoPrevisto = this.mesesDespesas.reduce((acc, el) => {
        return (
          acc +
          parseFloat(
            helpers.removerValor(
              el.rubricasPrevisto ? el.rubricasPrevisto.total || 0 : 0
            )
          )
        );
      }, 0);
      let custoRealizado = this.mesesDespesas.reduce((acc, el) => {
        return (
          acc +
          parseFloat(
            helpers.removerValor(
              el.rubricasRealizado ? el.rubricasRealizado.total || 0 : 0
            )
          )
        );
      }, 0);
      let notaPrevisto =
        this.mesesDespesas.reduce((acc, el) => {
          return (
            acc +
            parseFloat(
              helpers.removerValor(
                el.notasPrevistas ? el.notasPrevistas.total || 0 : 0
              )
            )
          );
        }, 0) +
        (this.componente == "n_previsto"
          ? this.totalNotas - this.valorAntigo
          : 0);
      let notaRealizado =
        this.mesesDespesas.reduce((acc, el) => {
          return (
            acc +
            parseFloat(
              helpers.removerValor(
                el.notasRealizadas ? el.notasRealizadas.total || 0 : 0
              )
            )
          );
        }, 0) +
        (this.componente == "previsto"
          ? this.totalNotas - this.valorAntigo
          : 0);

      return {
        custoPrevisto: custoPrevisto,
        custoRealizado: custoRealizado,
        notaPrevisto: notaPrevisto,
        notaRealizado: notaRealizado,
        restantePrevisto: custoPrevisto - notaPrevisto,
        restanteRealizado: custoRealizado - notaRealizado,
        totalPrevisto: custoPrevisto + notaPrevisto,
        totalRealizado: custoRealizado + notaRealizado,
      };
    },
    mesesDespesas: function () {
      if (!this.projeto.dataInicio) return [];
      let meses = helpers.criarArrayMesCronogramaFinanceiro(
        this.projeto.dataInicio,
        this.projeto.duracao
      );
      let mesesClone = cloneDeep(meses);

      meses.map((el) => {
        let rubricasPrevisto = [
          {
            label: "ST",
            valor: this.somarValoresPrevistosProposta("st", el.value),
          },
          {
            label: "RH",
            valor: this.proposta.rh
              .map((pessoa) => {
                let hora = pessoa.horasSazonais.find(
                  (hora) => hora.mes == el.value - 1
                );
                return hora ? hora.horas * pessoa.valorHora : 0;
              })
              .reduce((acc, el) => {
                return acc + el;
              }, 0),
          },
          {
            label: "MC",
            valor: this.somarValoresPrevistosProposta("mc", el.value),
          },
          {
            label: "MPE",
            valor: this.somarValoresPrevistosProposta("mpe", el.value),
          },
          {
            label: "VD",
            valor: this.somarValoresPrevistosProposta("vd", el.value),
          },
          {
            label: "OU",
            valor: this.somarValoresPrevistosProposta("ou", el.value),
          },
        ];

        let rubricasRealizado = [
          {
            label: "ST",
            valor: this.somarValoresRealizados("servicosTerceiros", el.value),
          },
          {
            label: "RH",
            valor: this.rubricas.recursoHumano
              ? this.rubricas.recursoHumano.equipe.alocacaoHorasIndividuais
                  .map((pessoa) => {
                    let hora = pessoa.horasSazonais.find(
                      (hora) => hora.mes == el.value - 1
                    );
                    return hora ? hora.horas * pessoa.valorHora : 0;
                  })
                  .reduce((acc, el) => {
                    return acc + el;
                  }, 0)
              : 0,
          },
          {
            label: "MC",
            valor: this.somarValoresRealizados("materiaisConsumo", el.value),
          },
          {
            label: "MPE",
            valor: this.somarValoresRealizados(
              "materiaisPermanentesEquipamentos",
              el.value
            ),
          },
          {
            label: "VD",
            valor: this.somarValoresRealizados("viagensDiarias", el.value),
          },
          {
            label: "OU",
            valor: this.somarValoresRealizados("outrosRecursos", el.value),
          },
        ];

        let notasPrevistas = this.dados.filter((item) => {
          return item.prazo == el.value;
        });

        let notasRealizadas = this.dados.filter((item) => {
          if (item.desembolso) {
            let ano = helpers.formatarData(
              item.desembolso.dataFaturamento,
              "YYYY"
            );
            let mes = helpers.formatarData(
              item.desembolso.dataFaturamento,
              "MM"
            );
            let x = mesesClone.find(
              (mesFind) => mesFind.mes == mes && mesFind.ano == ano
            );
            return el.value == (x ? x.value : null);
          } else return false;
        });

        let totalNotasPrevistas = notasPrevistas.reduce((total, item) => {
          return total + item.valor;
        }, 0);

        let totalNotasRealizadas = notasRealizadas.reduce((total, item) => {
          return total + item.desembolso.valorBruto;
        }, 0);

        let totalRubricasPrevistas = rubricasPrevisto.reduce((acc, el) => {
          return acc + el.valor;
        }, 0);

        let totalRubricasRealizadas = rubricasRealizado.reduce((acc, el) => {
          return acc + el.valor;
        }, 0);

        return Object.assign(el, {
          rubricasPrevisto: {
            rubricas: rubricasPrevisto.map((el) => {
              return {
                label: el.label,
                valor: helpers.formatarValor(el.valor),
              };
            }),
            total: helpers.formatarValor(totalRubricasPrevistas),
          },

          rubricasRealizado: {
            rubricas: rubricasRealizado.map((el) => {
              return {
                label: el.label,
                valor: helpers.formatarValor(el.valor),
              };
            }),
            total: helpers.formatarValor(totalRubricasRealizadas),
          },

          notasPrevistas: {
            total: helpers.formatarValor(totalNotasPrevistas),
            notas: notasPrevistas.map((el) => {
              return {
                id: el.id,
                tipo: el.tipo,
                valor: helpers.formatarValor(el.valor),
              };
            }),
          },
          notasRealizadas: {
            total: helpers.formatarValor(totalNotasRealizadas),
            notas: notasRealizadas.map((el) => {
              return {
                id: `r${el.id}`,
                tipo: el.tipo,
                valor: helpers.formatarValor(el.desembolso.valorBruto),
              };
            }),
          },

          totalPrevisto: helpers.formatarValor(
            totalNotasPrevistas + totalRubricasPrevistas
          ),
          totalRealizado: helpers.formatarValor(
            totalNotasRealizadas + totalRubricasRealizadas
          ),
        });
      });

      return meses;
    },
    nomeIdExecutora() {
      return this.$route.name == "projeto-detalhamento-executora-criadora"
        ? "projetoEmpresaExecutoraCriadoraId"
        : "projetoEmpresaExecutoraId";
    },
    colunas() {
      let empresasInvestidoras = this.options.empresasInvestidoras;
      let empresasRecebedoras = this.options.empresasRecebedoras;
      let mesesDespesas = this.mesesDespesas;
      if (this.$route.name.includes("executora"))
        return [
          {
            key: "tomadora",
            label: "Tomadora",
            formatter(value, i, row) {
              let empresa = empresasInvestidoras.find((x) => {
                return (
                  x.value ==
                  (row.projetoInvestidoraId ||
                    row.projetoCooperadaInvestidoraId)
                );
              });
              return value == "-1"
                ? "Total planejado"
                : value == "-2"
                ? "Total realizado"
                : empresa
                ? empresa.text
                : "";
            },
          },
          { key: "parcela", label: "Nº da parcela" },
          { key: "desembolso.numero", label: "Nº da nota fiscal" },
          {
            key: "prazo",
            label: "Mês planejado",
            formatter(value) {
              let mes = mesesDespesas.find((mes) => mes.value == value);
              return mes ? mes.text : "";
            },
          },
          {
            key: "valor",
            label: "Valor planejado",
            formatter: (value) => {
              if (value) return helpers.formatarValor(value);
            },
          },
          {
            key: "desembolso.dataFaturamento",
            label: "Data do faturamento",
            formatter: (value) => {
              if (value) return helpers.formatarDataBr(value);
            },
          },
          {
            key: "desembolso.valorBruto",
            label: "Valor realizado",
            formatter: (value) => {
              if (value) return helpers.formatarValor(value);
            },
          },
          {
            key: "subtipo",
            label: "Produto vinculado",
            formatter: (a, b, c) => {
              if (!a) return "";
              if(a == 'AssinaturaDoContrato') {
                return `Assinatura do Contrato`;
              }
              if (!c.entregavel) return "";
              if (
                c.entregavel.tipo == "RelatorioAtividades" &&
                c.entregavel.vinculadoARelatorioEtapa
              )
                return c.entregavel.relatorioEtapa.titulo;

              let tipoEntregavel = helpers.getTipoEntregavel(
                c.entregavel.tipo.trim()
              );
              let texto = tipoEntregavel.text;
              if (tipoEntregavel.value != tipoEntregavel.subtipo)
                texto = `${tipoEntregavel.text} - ${
                  helpers.getEnum(tipoEntregavel.subtipo).text
                }`;
              return `${texto} ${c.entregavel.sequencial}`;
            },

            /*formatter: (value, i, row) => {
              if (value)
                return helpers.getSubTipoCronogramaFinanceiro(
                  row.desembolso ? row.desembolso.subtipo : value
                ).text;
            },*/
          },
          { key: "actions", label: "Ações", thClass: "text-center" },
        ];
      else
        return [
          {
            key: "tomadora",
            label: "Tomadora",
            formatter(value, i, row) {
              let empresa = empresasInvestidoras.find((empresa) => {
                return (
                  empresa.value ==
                  (row.projetoInvestidoraId ||
                    row.projetoCooperadaInvestidoraId)
                );
              });
              return value == "-1" ? "Total" : empresa ? empresa.text : "";
            },
          },
          {
            key: "prestadora",
            label: "Prestadora",
            formatter(value, i, row) {
              let empresa = empresasRecebedoras.find((x) => {
                return (
                  x.value ==
                  (row.projetoEmpresaExecutoraCriadoraReceptoraId ||
                    row.projetoEmpresaExecutoraCriadoraId ||
                    row.projetoEmpresaExecutoraId)
                );
              });
              return empresa ? empresa.text : "";
            },
          },
          { key: "parcela", label: "Nº da parcela" },
          { key: "desembolso.numero", label: "Nº da nota fiscal" },
          {
            key: "prazo",
            label: "Mês planejado",
            formatter(value) {
              let mes = mesesDespesas.find((mes) => mes.value == value);
              return mes ? mes.text : "";
            },
          },
          {
            key: "valor",
            label: "Valor planejado",
            formatter: (value) => {
              if (value) return helpers.formatarValor(value);
            },
          },
          {
            key: "desembolso.dataFaturamento",
            label: "Data do faturamento",
            formatter: (value) => {
              if (value) return helpers.formatarDataBr(value);
            },
          },
          {
            key: "desembolso.valorBruto",
            label: "Valor realizado",
            formatter: (value) => {
              if (value) return helpers.formatarValor(value);
            },
          },
          {
            key: "subtipo",
            label: "Produto vinculado",
            formatter: (a, b, c) => {
              if (!a) return "";
              if (!c.entregavel) return "";
              if (
                c.entregavel.tipo == "RelatorioAtividades" &&
                c.entregavel.vinculadoARelatorioEtapa
              )
                return c.entregavel.relatorioEtapa.titulo;

              let tipoEntregavel = helpers.getTipoEntregavel(
                c.entregavel.tipo.trim()
              );
              let texto = tipoEntregavel.text;
              if (tipoEntregavel.value != tipoEntregavel.subtipo)
                texto = `${tipoEntregavel.text} - ${
                  helpers.getEnum(tipoEntregavel.subtipo).text
                }`;
              return `${texto} ${c.entregavel.sequencial}`;
            },
          },
          { key: "actions", label: "Ações", thClass: "text-center" },
        ];
    },
  },
};
</script>
<style></style>
